import { render } from "./FreeForAllRank.vue?vue&type=template&id=6253cbee&scoped=true&bindings={}"
import script from "./FreeForAllRank.vue?vue&type=script&lang=ts"
export * from "./FreeForAllRank.vue?vue&type=script&lang=ts"

import "./FreeForAllRank.vue?vue&type=style&index=0&id=6253cbee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6253cbee"

export default script